import { render, staticRenderFns } from "./WarehouseBasic.vue?vue&type=template&id=517aaf62"
import script from "./WarehouseBasic.vue?vue&type=script&lang=js"
export * from "./WarehouseBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports